var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"framework-button",style:(_vm.getStyling),attrs:{"outline":_vm.outline,"size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.clicked}},[_vm._t("button-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }